// Dependencies
import {
  ARTICULOS_REQUEST,
  ARTICULOS_OK,
  ARTICULOS_REFRESH,
  ARTICULOS_ERROR,
} from "./types";
import { get } from "../../../../api/apiInstance";

const fetchArticulos = () => async (dispatch) => {
  try {
    const response = await get("/articulos");
    const data = response["data"];
    dispatch({
      type: ARTICULOS_OK,
      payload: { data: data["data"], qty: data["rowsAffected"] },
    });
  } catch (error) {
    dispatch({ type: ARTICULOS_ERROR, payload: error });
  }
};

export const getArticulos = () => (dispatch) => {
  dispatch({ type: ARTICULOS_REQUEST });
  return dispatch(fetchArticulos());
};

export const refreshArticulos = () => (dispatch) => {
  dispatch({ type: ARTICULOS_REFRESH });
  return dispatch(fetchArticulos());
};
